import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { IconCircleCheckBoldComponent } from '../icon-circle-check-bold/icon-circle-check-bold.component';
import { IconErrorDiamondBoldComponent } from '../icon-error-diamond-bold/icon-error-diamond-bold.component';
import { IconInformationCircleBoldComponent } from '../icon-information-circle-bold/icon-information-circle-bold.component';
import { IconWarningTriangleBoldComponent } from '../icon-warning-triangle-bold/icon-warning-triangle-bold.component';
import { Notification } from '../../models/notification.type';


interface Data {
  notificationType: Notification;
  text: string;
}

const containerClassMapper: Record<Notification, string> = {
  error: 'snackbar-notification--error',
  warning: 'snackbar-notification--warning',
  success: 'snackbar-notification--success',
  information: 'snackbar-notification--info',
};

@Component({
    selector: 'app-snackbar-notification',
    templateUrl: './snackbar-notification.component.html',
    styleUrls: ['./snackbar-notification.component.scss'],
    imports: [
    IconCircleCheckBoldComponent,
    IconWarningTriangleBoldComponent,
    IconErrorDiamondBoldComponent,
    IconInformationCircleBoldComponent
]
})
export class SnackbarNotificationComponent implements OnInit {
  containerClass: string;
  constructor(
    public snackBarRef: MatSnackBarRef<SnackbarNotificationComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: Data
  ) {}

  ngOnInit(): void {
    this.containerClass = this.getContainerClass(this.data.notificationType);
  }
  getContainerClass(notificationType: Notification): string {
    return containerClassMapper[notificationType] || 'snackbar-notification--info';
  }
}
